import axios from "axios";
import { getAPIUrl } from "../../../../Constants.ts";
import { UserFormRequest, userReuest } from "./_models";

const API_URL = getAPIUrl();

const UPDSERT_USER = `${API_URL}/values/UpsertUser`;
const UPDSERT_USER_REQUEST = `${API_URL}/values/UpsertUserRequest`;


export function UpsertUser(request: any) {
    return axios.post<string>(UPDSERT_USER, request);
}

export function UpsertUserRequest(request: userReuest) {
    return axios.post<string>(UPDSERT_USER_REQUEST, request);
}

